"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PARENT_NAVIGATION_ROUTE = exports.LOCAL_STORAGE_KEYS = void 0;
var PARENT_NAVIGATION_ROUTE = 'parentNavigationRoute';
exports.PARENT_NAVIGATION_ROUTE = PARENT_NAVIGATION_ROUTE;
var LOCAL_STORAGE_KEYS = {
  SIDENAV_PINNED: 'sidenav_pinned',
  SIDENAV_PINNED_VALUE: 'true',
  SIDENAV_TABS_EXPANDED: 'sidenav_tabs_expanded'
};
exports.LOCAL_STORAGE_KEYS = LOCAL_STORAGE_KEYS;